
// Confetti
// import JSConfetti from 'js-confetti'

export default {
  props: {
    label: String,
    filename: String,
    content: Number,
    min: Number,
    max: Number,
    step: Number,
    icons: Array,
  },

  data() {
    return {
      bottom: {
        val: 0,
      },

      // Confetti
      // confettiObj: null,
    }
  },

  computed: {
    _content: {
      set(value) {
        // console.log(value, this.max, this.min)
        this.bottom.val = ((value - this.min) * 100) / (this.max - this.min) // ((value * 100 / this.max) - 10) + ((value * 10 / this.max) - 1)
        this.$emit('update:content', value)
      },

      get() {
        return this.content
      },
    },
    currentIcon() {
      if (!this.icons?.length) return null

      const icon = this.icons.find(
        (i) => parseInt(i.content.step) >= this._content,
      )

      return icon?.content?.icon?.[0]?.filename
    },

    // Confetti
    // isAtMax() {
    //   return this._content === this.max
    // },
  },

  // Confetti
  // watch: {
  //   isAtMax(val) {
  //     if (val)
  //       this.confettiObj.addConfetti({
  //         emojis: ['💸', '🍳', '🍽️', '✨', '👩‍🍳', '🍷'],
  //       })
  //   },
  // },

  mounted() {
    if (this.content === undefined) this._content = this.min + this.step

    // Confetti
    // this.confettiObj = new JSConfetti()
  },
}
